import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'surface_mount_carriers/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
